module.exports = __webpack_public_path__ + "img/38.f22ffb3b.png";